export default __webpack_public_path__ + "static/girl-looking-distance-b1886162bd3aa7a44342c2cead6c55d8.jpg";